import { render, staticRenderFns } from "./ProductItemCreateScreen.vue?vue&type=template&id=0f717c29&"
import script from "./ProductItemCreateScreen.vue?vue&type=script&lang=js&"
export * from "./ProductItemCreateScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports